export default "__VITE_ASSET__IUpPlF3a__"